import { Svg } from '../../../LegacyApp/client/components/svg/Svg';

const Icon = () => {
	return Svg({
		content: (
			<g>
				<circle fill="#02ec97" cx="45.1" cy="45" r="45" />
				<path d="M61.3,20.8l-11.3,16.7c-.8,1.1.7,2.5,1.8,1.6l11.1-9.6c.3-.2.7,0,.7.4v30.1c0,.4-.5.6-.8.3L29.3,20.1c-1.1-1.3-2.6-2-4.4-2h-1.2c-3.1,0-5.7,2.6-5.7,5.8v42.4c0,3.2,2.6,5.8,5.8,5.8s3.8-1,4.9-2.8l11.3-16.7c.8-1.1-.7-2.5-1.8-1.6l-11.1,9.6c-.3.2-.7,0-.7-.4v-30.1c0-.4.5-.6.8-.3l33.6,40.2c1.1,1.3,2.7,2,4.4,2h1.2c3.2,0,5.8-2.6,5.8-5.8V23.8c0-3.2-2.6-5.8-5.8-5.8s-3.9,1-5,2.8Z" />
			</g>
		),
		width: 90,
		height: 90,
		viewBox: '0 0 90.1 90',
	});
};

export default Icon;
